import React, { Component } from 'react';
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton';
import SchedulleStore from './SchedulleStore'

export default class SchedulleCard extends Component {
    constructor(props) {
        super();
        this.handleScheduleEdit = this.handleScheduleEdit.bind(this);
    }

    minutesToTimeStr(minutes) {
        var result = "";
        var hours = Math.floor(minutes / 60);
        if (hours !== 0) {
            result += hours + "ч "
        }

        minutes = minutes % 60;

        if (minutes > 10 || (minutes > 0 && hours === 0)) {
            result += minutes + "м"
        }
        else if (minutes > 0) {
            result += "0" + minutes + "м"
        }

        return result;
    }

    handleScheduleEdit() {
        SchedulleStore.openSchedulleEditDialog(this.props.work, this.minutesToTimeStr(this.props.work.minutes));
    }

    render() {
        return (
            <div className="schedulle-card clearfix">
                <div className="schedule-card-caption">{this.props.work.workNumber}</div>
                <div className="schedulle-edit-button"><IconButton size="small" onClick={this.handleScheduleEdit}><EditIcon /></IconButton></div>
                <div>
                    <div className="schedule-card-description">
                        {this.props.work.workCaption}
                        <br/>
                        {this.props.work.userName}
                    </div>
                    <div className="schedule-card-time">
                        {this.minutesToTimeStr(this.props.work.minutes)}
                    </div>
                </div>
            </div>);
    }
}